import React, { useEffect, useState } from "react";
import { api, formatApiError, formatDate } from "../../lib/api";
import { toast } from "sonner";

const LABEL = {
  backfill_safe_assignment: "Safe assignment", review_merge_approved: "Approved merge (review)",
  review_merge_rejected: "Rejected suggestion", review_rejection_undone: "Rejection undone",
  manual_merge: "Manual merge", merge: "Merge", split: "Split",
};

export const AuditLogPanel = ({ refreshKey }) => {
  const [events, setEvents] = useState(null);
  useEffect(() => {
    api.get("/operations/payoffs/client-groups/events", { params: { limit: 200 } })
      .then(({ data }) => setEvents(data)).catch((e) => toast.error(formatApiError(e)));
  }, [refreshKey]);
  if (!events) return <div className="text-sm text-[#6B7280]">Loading…</div>;
  if (!events.length) return <div className="text-sm text-[#6B7280]" data-testid="audit-empty">No grouping changes recorded yet.</div>;
  return (
    <div className="border border-[#E5E7EB] rounded-xl bg-white divide-y divide-[#F3F4F6]" data-testid="audit-log-panel">
      {events.map((ev, i) => (
        <div key={ev.event_id || i} className="px-4 py-2.5 text-xs grid grid-cols-[150px_180px_1fr] gap-3" data-testid={`audit-event-${i}`}>
          <span className="text-[#6B7280] tabular-nums">{formatDate(ev.created_at)}</span>
          <span className="font-semibold text-[#0A2540]">{LABEL[ev.event_type] || ev.event_type}</span>
          <span className="text-[#374151]">
            {ev.target_group_id && <span className="font-mono">{ev.source_group_id ? `${ev.source_group_id} → ` : "→ "}{ev.target_group_id} </span>}
            {ev.moved_loan_ids?.length > 0 && <span>· {ev.moved_loan_ids.length} loan(s): <span className="font-mono">{ev.moved_loan_ids.slice(0, 6).join(", ")}{ev.moved_loan_ids.length > 6 ? "…" : ""}</span> </span>}
            · {ev.by_email}{ev.note ? ` — “${ev.note}”` : ""}
          </span>
        </div>
      ))}
    </div>
  );
};
